<template lang="pug">

  #application
    #notification-panel
      transition-group(name="fade")
        notification(
          :key="n.title",
          :notification="n",
          v-for="(n,i) in notificationsStore.notifications"
        )
    .upperBar(v-if="title && title != ''") {{ title }}
    router-view
    // all ModalReveal content will be injected here
    #global-modal-container
</template>

<script type="text/babel">
import {mapState} from 'vuex'
import Notification from './components/structure/Notification.vue'

export default {
  name: "App",
  computed: {
    ...mapState({
      notificationsStore: state => state.notificationsStore
    }),
    title: function () {
      return window.env.UPPER_BAR
    },
  },
  components: {
    Notification
  },
  created: function () {

  }
}
</script>

<style lang="sass">
/*select
  -webkit-appearance: none
  -moz-appearance: none
  text-indent: 1px
  text-overflow: ''*/
.upperBar
  text-align: center
  font-weight: 600
  background: yellow
  color: black
  font-family: monospace !important
  font-size: 1.25em !important
  border: solid black
  border-width: 1px 0 1px 0
  margin: .25em 0
</style>



// WEBPACK FOOTER //
// App.vue?5d4186d9